import * as React from "react";
const SvgCaretDownIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", "data-icon": "caretDown", role: "img", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" }));
export default SvgCaretDownIcon;
